import DOMPurify from 'dompurify'

/**
 * Sanitiza HTML para prevenir XSS antes de usar dangerouslySetInnerHTML.
 * Permite tags seguros como audio, video, img, tablas, etc.
 */
export function sanitizeHtml(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    ADD_TAGS: ['audio', 'source', 'iframe'],
    ADD_ATTR: [
      'controls', 'controlsList', 'src', 'type', 'allowfullscreen',
      'allow', 'frameborder', 'class', 'style', 'target', 'rel'
    ],
    FORBID_TAGS: ['script', 'object', 'embed', 'form'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur']
  })
}

/**
 * Sanitiza HTML estricto - sin iframes ni audio (para contenido de usuario puro).
 */
export function sanitizeHtmlStrict(dirty: string): string {
  return DOMPurify.sanitize(dirty, {
    FORBID_TAGS: ['script', 'object', 'embed', 'form', 'iframe', 'audio', 'video'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur']
  })
}
